import { BsPencil } from "react-icons/bs";
import { FaEye } from "react-icons/fa";
import { MdOutlineDeleteForever } from "react-icons/md";
import { useDisclosure } from "@chakra-ui/react";
import { DeleteB2BWorkshopModal } from "../Modals/DeleteB2BWorkshopModal";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useToast } from "@chakra-ui/react";
import { Col, Button, Row, Form } from "react-bootstrap";
import { CheckIcon, EditIcon } from "@chakra-ui/icons";
import WorkshopB2BDataService from "../../services/WorkshopB2B";

export const SingleWorkshopB2BRow = ({ props, func, id }: any) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();
  const {
    title,
    date,
    start_time,
    end_time,
    status,
    location,
    state,
    corporate,
    expert_name,
    expert_price,
    tds,
    payment_after_tds,
    payment_status,
  } = props;

  const navigate = useNavigate();
  const [modal, setModal] = useState("");

  const [tdsEditable, setTdsEditable] = useState(false);
  const [paymentStatusEditable, setPaymentStatusEditable] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(payment_status);
  const [tdsValue, setTdsValue] = useState(tds);
  const [paymentAfterTdsValue, setPaymentAfterTdsValue] =
    useState(payment_after_tds);

  const handleTdsValue = (event: any) => {
    event.preventDefault();
    const expertPriceInt = parseInt(expert_price) || 0;
    const tdsValueInt = parseInt(tdsValue) || 0;
    setPaymentAfterTdsValue(expertPriceInt - tdsValueInt);
    const data = {
      ...props,
      tds: tdsValue,
      payment_after_tds: expertPriceInt - tdsValueInt,
    };

    WorkshopB2BDataService.updateB2BWorkshop(id, data)
      .then((res: any) => {
        setTdsEditable(false);
        toast({
          position: "top",
          title: "TDS Value Saved Successfully",
          description: "The TDS Value has been saved successfully",
          status: "success",
          duration: 1500,
          isClosable: true,
        });
      })
      .catch((e) => {
        toast({
          position: "top",
          title: "TDS Value  Save Failed",
          description:
            "There was an error saving the TDS Value. Please try again later.",
          status: "error",
          duration: 1500,
          isClosable: true,
        });
      });
  };

  const handlePaymentStatus = (event: any) => {
    event.preventDefault();
    setPaymentStatus(paymentStatus);

    const data = {
      ...props,
      payment_status: paymentStatus,
    };

    WorkshopB2BDataService.updateB2BWorkshop(id, data)
      .then((res: any) => {
        setPaymentStatusEditable(false);
        toast({
          position: "top",
          title: "Payment Status Saved Successfully",
          description: "Payment Status has been saved successfully",
          status: "success",
          duration: 1500,
          isClosable: true,
        });
      })
      .catch((e) => {
        toast({
          position: "top",
          title: "Payment Status Save Failed",
          description:
            "There was an error saving the Payment Status. Please try again later.",
          status: "error",
          duration: 1500,
          isClosable: true,
        });
      });
  };

  function getMonthName(monthNumber: number) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return months[monthNumber - 1];
  }

  const getFormattedDate = (date: string) => {
    if (!date) return "";
    const dateComponents = date.split("/");
    const year = dateComponents[2].substring(2);
    const formattedDate = `${parseInt(dateComponents[1])}/${getMonthName(
      parseInt(dateComponents[0])
    )}/${year}`;
    return formattedDate;
  };

  useEffect(() => {
    setTdsValue(tds);
  }, [tds]);

  useEffect(() => {
    setPaymentStatus(payment_status);
  }, [payment_status]);

  useEffect(() => {
    setPaymentAfterTdsValue(payment_after_tds);
  }, [payment_after_tds]);

  return (
    <tr>
      <td>
        <div
          className="edit-icon"
          onClick={() => navigate(`/workshopsb2b/edit/${id}`)}
        >
          <BsPencil />
        </div>
      </td>
      <td>
        <div className="d-flex align-items-center">
          <button
            type="button"
            className="btn disabledButton"
            onClick={() => navigate(`/workshopsb2b/view/${id}`)}
          >
            <FaEye style={{ color: "#f48a0f" }} />
          </button>
        </div>
      </td>
      <td>{title}</td>
      <td>{getFormattedDate(date)}</td>
      {/* <td>{start_time}</td> */}
      {/* <td>{end_time}</td> */}
      <td>{status}</td>
      <td>{location}</td>
      {/* <td>{state}</td> */}
      <td>{corporate}</td>
      <td> {expert_name} </td>
      <td> {expert_price} </td>
      <td>
        <Row>
          <Col xs={6}>
            <Form.Control
              type="text"
              value={tdsValue}
              onChange={(e) => setTdsValue(e.target.value)}
              disabled={!tdsEditable}
              style={{ width: "90px" }}
            />
          </Col>
          <Col xs={3}>
            {tdsEditable ? (
              <Button className="sheet_btn" onClick={handleTdsValue}>
                <CheckIcon />
              </Button>
            ) : (
              <Button
                className=" sheet_btn"
                onClick={() => setTdsEditable(true)}
              >
                <EditIcon />
              </Button>
            )}
          </Col>
        </Row>
      </td>
      <td> {paymentAfterTdsValue} </td>
      <td>
        <Row>
          <Col xs={7}>
            <Form.Select
              value={paymentStatus}
              onChange={(e) => setPaymentStatus(e.target.value)}
              disabled={!paymentStatusEditable}
              style={{
                width: "110px",
                zIndex: "2",
                color:
                  paymentStatus === "approved"
                    ? "green"
                    : paymentStatus === "hold"
                    ? "orange"
                    : paymentStatus === "rejected"
                    ? "red"
                    : "gray",
              }}
              className="custom-select"
            >
              <option value="" style={{ color: "black" }}>
                Select
              </option>
              <option value="approved" style={{ color: "green" }}>
                Approved
              </option>
              <option value="hold" style={{ color: "orange" }}>
                Hold
              </option>
              <option value="rejected" style={{ color: "red" }}>
                Rejected
              </option>
            </Form.Select>
          </Col>
          <Col xs={3}>
            {paymentStatusEditable ? (
              <Button className="sheet_btn" onClick={handlePaymentStatus}>
                <CheckIcon />
              </Button>
            ) : (
              <Button
                className=" sheet_btn"
                onClick={() => setPaymentStatusEditable(true)}
              >
                <EditIcon />
              </Button>
            )}
          </Col>
        </Row>
      </td>
      <td>
        <div className="d-flex align-items-center">
          <span title="Delete">
            <MdOutlineDeleteForever
              className="deleteButton pointer"
              onClick={() => {
                setModal("deletemodal");
                onOpen();
              }}
            />
          </span>
        </div>
      </td>
      {modal === "deletemodal" && (
        <DeleteB2BWorkshopModal
          isOpen={isOpen}
          onClose={onClose}
          func={func}
          id={id}
        />
      )}
    </tr>
  );
};
